import { NotificationDto } from "@gap/backend/app-services/notification/models/NotificationDto"
import DateUtils from "@gap/utils/date-utils"
import { makeAutoObservable } from "mobx"
import { createStoreContext } from "reusable/mobx-store-utils/storeUtils"
import { NotificationsStore } from "./NotificationsStore"
import { apiClient } from "api/trpc/trpc-client"
import { RouteType } from "@gap/utils/utils"
import Loader from "reusable/mobx-helpers/Loader"

interface NotificationStoreProps {
   notification: NotificationDto
   notificationsStore: NotificationsStore
}

export default class NotificationStore {
   sp
   loader = new Loader()

   constructor(sp: NotificationStoreProps) {
      makeAutoObservable(this)
      this.sp = sp
   }

   get notificationDate() {
      return DateUtils.formatAsRelativeTime({ compareTime: new Date(this.sp.notification.createdAt) })
   }

   onNotificationClick = async () => {
      await this.loader.executeLoading(async () => {
         if (!this.sp.notification.read) {
            this.sp.notification.read = true
            await apiClient.notifications.markAsRead.mutate({ id: this.sp.notification.id })
         }

         this.performNotificationAction()
      })
   }

   performNotificationAction = () => {
      this.sp.notificationsStore.sp.mainContainerStore.notificationsState.close()

      if (this.sp.notification.action?.url) {
         if (this.sp.notification.action.url.startsWith('http')) {
            window.location.href = this.sp.notification.action.url
         } else {
            const route = this.sp.notification.action.url.startsWith('/') ? this.sp.notification.action.url : `/${this.sp.notification.action.url}`
            this.sp.notificationsStore.sp.routerStore.goToNavPath(route as RouteType)
         }
      }

      if (this.sp.notification.action?.dialog) {
         switch (this.sp.notification.action.dialog) {
            default:
               throw new Error(`Unsupported dialog option for ${this.sp.notification.action.dialog}`)
         }
      }
   }
}

export const { Provider: NotificationStoreProvider, useProvidedStore: useNotificationStore } = createStoreContext(NotificationStore)
